import { render, staticRenderFns } from "./LeaveWithConsentTab.vue?vue&type=template&id=0badbf79"
import script from "./LeaveWithConsentTab.vue?vue&type=script&lang=js"
export * from "./LeaveWithConsentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports